import React from 'react';
import { X, AlertTriangle, Trash2 } from 'lucide-react';

const DoctorDeleteModalSimple = ({ doctor, isOpen, onClose, onConfirm }) => {
  if (!isOpen || !doctor) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-bold text-gray-900">Confirmer la suppression</h2>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 transition-colors duration-200"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="flex items-center mb-4">
            <div className="flex-shrink-0">
              <AlertTriangle className="h-8 w-8 text-red-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-lg font-medium text-gray-900">
                Supprimer le médecin
              </h3>
              <p className="text-sm text-gray-500 mt-1">
                Cette action est irréversible.
              </p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-700">
              <strong>Médecin:</strong> {doctor.user?.name || 'N/A'}<br />
              <strong>Spécialité:</strong> {doctor.specialty || 'N/A'}<br />
              <strong>Hôpital:</strong> {doctor.hospital || 'N/A'}
            </p>
          </div>

          <p className="text-sm text-gray-600 mb-6">
            Êtes-vous sûr de vouloir supprimer ce médecin ? Toutes les données associées seront définitivement supprimées.
          </p>

          {/* Actions */}
          <div className="flex space-x-4">
            <button
              onClick={onClose}
              className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-700 py-3 px-6 rounded-lg transition-colors duration-200"
            >
              Annuler
            </button>
            <button
              onClick={() => {
                onConfirm(doctor.id);
                onClose();
              }}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white py-3 px-6 rounded-lg flex items-center justify-center space-x-2 transition-colors duration-200"
            >
              <Trash2 className="h-5 w-5" />
              <span>Supprimer</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorDeleteModalSimple;
